export const sampleModuleResponse = {
    id: 5587152151,
    name: 'groupAbout',
    position: 1,
    zoneId: 1,
    zonename: 'top_left',
    version: 0,
    privileges: {
        edit: true,
        delete: true
    },
    moduleData: {
        dataKey: 'groupAbout',
        groupAbout: {
            tagline: 'Sample tagline',
            description: ''
        }
    }
};

//# sourceMappingURL=sampleData.js.map